import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterTag = ({ index, label, light = false }) => (
  <span
    data-testid={`chapter-tag-${index}`}
    className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border text-[11px] font-mono tracking-[0.25em] uppercase ${
      light ? "bg-black/[0.04] border-black/10 text-gold-muted" : "bg-white/[0.05] border-white/10 text-gold"
    }`}
  >
    <span className="opacity-60">{index}</span>
    <span>{label}</span>
  </span>
);

export const GoldButton = ({ children, onClick, href, testId, className = "", type = "button" }) => {
  const cls = `inline-flex items-center justify-center gap-2 rounded-full bg-gold px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-obsidian transition-colors duration-300 hover:bg-gold-hover shadow-[0_0_25px_rgba(197,160,89,0.15)] ${className}`;
  if (href) {
    return (
      <a data-testid={testId} href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" className={cls}>
        {children}
      </a>
    );
  }
  return (
    <button data-testid={testId} type={type} onClick={onClick} className={cls}>
      {children}
    </button>
  );
};

export const GhostButton = ({ children, onClick, href, testId, className = "" }) => {
  const cls = `inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-zinc-100 transition-colors duration-300 hover:border-gold hover:text-gold ${className}`;
  if (href) {
    return (
      <a data-testid={testId} href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" className={cls}>
        {children}
      </a>
    );
  }
  return (
    <button data-testid={testId} type="button" onClick={onClick} className={cls}>
      {children}
    </button>
  );
};
